export default "__VITE_ASSET__BgB$OqV0__"